// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-progress-circular {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-progress-circular > svg {
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
}

:where(.vuetify-styles) .v-progress-circular__content {
  align-items: center;
  display: flex;
  justify-content: center;
}

:where(.vuetify-styles) .v-progress-circular__underlay {
  color: rgba(var(--v-border-color), var(--v-border-opacity));
  stroke: currentColor;
  z-index: 1;
}

:where(.vuetify-styles) .v-progress-circular__overlay {
  stroke: currentColor;
  transition: all 0.2s ease-in-out, stroke-width 0s;
  z-index: 2;
}

:where(.vuetify-styles) .v-progress-circular--revealing {
  --progress-reveal-duration: \$progress-circular-reveal-duration;
}
:where(.vuetify-styles) .v-progress-circular--revealing .v-progress-circular__overlay {
  transition-duration: var(--progress-reveal-duration), 0s;
}

:where(.vuetify-styles) .v-progress-circular--size-x-small {
  height: 16px;
  width: 16px;
}
:where(.vuetify-styles) .v-progress-circular--size-small {
  height: 24px;
  width: 24px;
}
:where(.vuetify-styles) .v-progress-circular--size-default {
  height: 32px;
  width: 32px;
}
:where(.vuetify-styles) .v-progress-circular--size-large {
  height: 48px;
  width: 48px;
}
:where(.vuetify-styles) .v-progress-circular--size-x-large {
  height: 64px;
  width: 64px;
}

:where(.vuetify-styles) .v-progress-circular--indeterminate > svg {
  animation: progress-circular-rotate 1.4s linear infinite;
  transform-origin: center center;
  transition: all 0.2s ease-in-out;
}
:where(.vuetify-styles) .v-progress-circular--indeterminate .v-progress-circular__overlay {
  animation: progress-circular-dash 1.4s ease-in-out infinite, progress-circular-rotate 1.4s linear infinite;
  stroke-dasharray: 25, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  transform-origin: center center;
  transform: rotate(-90deg);
}

:where(.vuetify-styles) .v-progress-circular--disable-shrink > svg {
  animation-duration: 0.7s;
}
:where(.vuetify-styles) .v-progress-circular--disable-shrink .v-progress-circular__overlay {
  animation: none;
}

:where(.vuetify-styles) .v-progress-circular--indeterminate:not(.v-progress-circular--visible) > svg,
:where(.vuetify-styles) .v-progress-circular--indeterminate:not(.v-progress-circular--visible) .v-progress-circular__overlay {
  animation-play-state: paused !important;
}

@keyframes progress-circular-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -124px;
  }
}
@keyframes progress-circular-rotate {
  100% {
    transform: rotate(270deg);
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VProgressCircular/VProgressCircular.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,8DAA8D;AAChE;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,0GAA0G;EAC1G,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".v-progress-circular {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  vertical-align: middle;\n}\n.v-progress-circular > svg {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 0;\n}\n\n.v-progress-circular__content {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.v-progress-circular__underlay {\n  color: rgba(var(--v-border-color), var(--v-border-opacity));\n  stroke: currentColor;\n  z-index: 1;\n}\n\n.v-progress-circular__overlay {\n  stroke: currentColor;\n  transition: all 0.2s ease-in-out, stroke-width 0s;\n  z-index: 2;\n}\n\n.v-progress-circular--revealing {\n  --progress-reveal-duration: $progress-circular-reveal-duration;\n}\n.v-progress-circular--revealing .v-progress-circular__overlay {\n  transition-duration: var(--progress-reveal-duration), 0s;\n}\n\n.v-progress-circular--size-x-small {\n  height: 16px;\n  width: 16px;\n}\n.v-progress-circular--size-small {\n  height: 24px;\n  width: 24px;\n}\n.v-progress-circular--size-default {\n  height: 32px;\n  width: 32px;\n}\n.v-progress-circular--size-large {\n  height: 48px;\n  width: 48px;\n}\n.v-progress-circular--size-x-large {\n  height: 64px;\n  width: 64px;\n}\n\n.v-progress-circular--indeterminate > svg {\n  animation: progress-circular-rotate 1.4s linear infinite;\n  transform-origin: center center;\n  transition: all 0.2s ease-in-out;\n}\n.v-progress-circular--indeterminate .v-progress-circular__overlay {\n  animation: progress-circular-dash 1.4s ease-in-out infinite, progress-circular-rotate 1.4s linear infinite;\n  stroke-dasharray: 25, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  transform-origin: center center;\n  transform: rotate(-90deg);\n}\n\n.v-progress-circular--disable-shrink > svg {\n  animation-duration: 0.7s;\n}\n.v-progress-circular--disable-shrink .v-progress-circular__overlay {\n  animation: none;\n}\n\n.v-progress-circular--indeterminate:not(.v-progress-circular--visible) > svg,\n.v-progress-circular--indeterminate:not(.v-progress-circular--visible) .v-progress-circular__overlay {\n  animation-play-state: paused !important;\n}\n\n@keyframes progress-circular-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0px;\n  }\n  50% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -124px;\n  }\n}\n@keyframes progress-circular-rotate {\n  100% {\n    transform: rotate(270deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
